var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8869 24.1508H8.51883V0H25.116C26.6463 0 27.8869 1.24055 27.8869 2.77084L27.8869 24.1508Z",
    fill: "#64AB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.6085 24.1464H8.52278V0.00012207H11.1742C10.2416 3.12696 9.87591 6.61039 10.205 10.2401C10.7079 15.6893 12.7011 20.5258 15.6085 24.1464Z",
    fill: "#224735"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7478 12.3187H13.6579C12.9801 12.3187 12.4305 11.7691 12.4305 11.0913V5.55454C12.4305 4.87667 12.9801 4.32715 13.6579 4.32715H22.7478C23.4256 4.32715 23.9752 4.87667 23.9752 5.55454V11.0913C23.9752 11.7691 23.4256 12.3187 22.7478 12.3187Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51883 25.9696V0C6.08563 0 4.11314 1.97249 4.11314 4.40569V26.0913C4.11314 28.5245 6.08563 30.497 8.51883 30.497H25.8746C26.986 30.497 27.8868 29.5961 27.8868 28.4848V25.9696H8.51883Z",
    fill: "#429E71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.245 30.5007H8.52279C6.08161 30.5007 4.11593 28.5258 4.11593 26.0938V4.40698C4.11593 1.97501 6.08161 0.00012207 8.52279 0.00012207V25.9658H17.245C19.5582 28.2607 22.3011 29.8516 25.245 30.5007Z",
    fill: "#224735"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8869 27.7883H8.61394C7.60945 27.7883 6.79515 26.974 6.79515 25.9696C6.79515 24.9651 7.60945 24.1508 8.61394 24.1508H27.8869V27.7883Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.3753 27.7852H8.61419C7.6085 27.7852 6.79477 26.9715 6.79477 25.9658C6.79477 25.4629 6.99588 25.0149 7.32507 24.6858C7.6542 24.3475 8.11134 24.1464 8.61418 24.1464H15.6085C16.7331 25.5635 18.0039 26.7886 19.3753 27.7852Z",
    fill: "#224735"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 31.8364L12.6371 31.0252L11.6738 31.8364C11.2248 32.2144 10.5388 31.8953 10.5388 31.3083V24.1508H14.7354V31.3083C14.7354 31.8953 14.0494 32.2144 13.6004 31.8364Z",
    fill: "#F5B95F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.86028b1255e21cf9f6fed5c11f2cfd84.svg";
export { ForwardRef as ReactComponent };